import logo from '@src/assets/voylogic-header-logo.png';

import classes from './logo.module.css';
import { Link } from 'react-router-dom';

function Logo() {
  return (
    <Link to="/">
      <span className={classes.logoWrapper}>
        <img src={logo} className={classes.logo} alt="VoyLogic Logo" />
        <sup className={classes.trademark}>&trade;</sup>
      </span>
    </Link>
  );
}

export default Logo;
